import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowDotPlotsBoxesConverter extends CmsConverterService<PanelRowDotPlotsBoxesData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    let boxes = formData.st_panel_row_dot_plots_boxes?.value ?? []
    boxes = boxes.map((box: any) => ({
      ...box,
      index: boxes.indexOf(box) ?? 0
    }))
    const dotPlotsBoxes = {
      name: formData.st_panel_row_dot_plots_boxes?.name ?? '',
      value: boxes
    }
    return {
      footer: formData.st_panel_dot_plots_boxes_footer ?? defaultTextInput,
      header: formData.st_panel_dot_plots_boxes_header ?? defaultTextInput,
      headline: formData.st_panel_dot_plots_boxes_headline ?? defaultTextInput,
      boxes: dotPlotsBoxes,
      fourBoxesLayout: formData.st_fourBoxesLayout?.value ?? false,
      isFaq: false
    }
  }
}

export const PANEL_ROW_DOT_PLOTS_BOXES_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowDotPlotsBoxesData>>('PanelRowDotPlotsBoxesConverter')

export interface PanelRowDotPlotsBoxesData extends ConvertedComponentData {
  footer: TextInput;
  header: TextInput;
  headline: TextInput;
  boxes: FsCatalog;
  fourBoxesLayout: boolean;
  isFaq: boolean;
}
